import { useCallback, useRef } from 'react';

export const useDebounceCallback = (callback, delay = 300) => {
  const timerRef = useRef(null);

  const debouncedFn = useCallback(
    (...args) => {
      clearTimeout(timerRef.current);

      timerRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  return debouncedFn;
};

export default useDebounceCallback;
